import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComboObjetivoComponent} from './combo-objetivo.component';
import {MaterialCommonModule} from 'src/app/material-modules/material-common.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {ComboPesquisavelModule} from '../combo-pesquisavel/combo-pesquisavel.module';


@NgModule({
    declarations: [ComboObjetivoComponent],
    imports: [
        CommonModule,
        MaterialCommonModule,
        MatExpansionModule,
        ComboPesquisavelModule
    ],
    exports: [ComboObjetivoComponent]
})
export class ComboObjetivoModule {
}
